import type { AuthModel } from "pocketbase";

import { pick } from "#utilities/manipulators";
import type { Account } from "./account.types";

export const mapRecordToAccount = (record: NonNullable<AuthModel>): Account => ({
  ...pick(record, ["createdAt", "email", "name", "id"]),
  verified: !!record.verified,
});

export const getInitials = (name: string | undefined) => {
  return name
    ?.split(" ")
    .slice(0, 2)
    .reduce((accum, part) => accum + (part.replace(/[^a-z]/gi, "")[0] ?? ""), "");
};
